import React from "react";

export default function CustomerUploadedFiles(props) {
    return (
        <ul className="attachments">
            {props.files.map((file, index) => {
                return (
                    <li key={index}>
                        <a
                            className="attachmentName"
                            href={'/order/downloadFile/'+file.unique_hash}
                            title="Klicka för att ladda ner filen"
                        >
                            {file.name}
                        </a>
                    </li>
                );
            })}
        </ul>
    );
}
